import { APP_SLUG } from "./global";

// // PRODUCTION K8
// export const AUTH_API_URL = "https://ms-account.nexah.net/api/";
// export const AUTH_URL = "https://account.nexah.net/";
// //export const AUTH_URL = "http://192.0.0.1:3000/";

// export const APP_API_URL = "https://ms-emailing.nexah.net/api/v1/";
// export const AUTH_SIGN_IN_URL = `${AUTH_URL}connect/${APP_SLUG}`;


// DEPLOYMENT K8
export const AUTH_API_URL = "NXH_MS_ACCOUNT_API_BASE_URL_PLACEHOLDER";
export const AUTH_URL = "NXH_MS_ACCOUNT_APP_BASE_URL_PLACEHOLDER";
export const APP_API_URL = "NXH_API_BASE_URL_PLACEHOLDER";
export const AUTH_SIGN_IN_URL = `${AUTH_URL}connect/${APP_SLUG}`;